<template>
  <section class="itinerario-poster" ref="sectionRef">
    <h2 class="poster-title">Itinerario</h2>

    <div
      v-for="(evento, index) in eventos"
      :key="evento.nombre"
      class="poster-item"
      :ref="el => itemRefs[index] = el"
    >
      <img :src="evento.icono" class="poster-icon" alt="Icono evento" />
      <p class="poster-text">
        <span class="evento-nombre">{{ evento.nombre }}</span>
        <span class="evento-hora">{{ evento.hora }}</span>
        <span v-if="evento.nota" class="evento-nota">{{ evento.nota }}</span>
      </p>
    </div>
  </section>
</template>

<script>
import { ref, onMounted } from 'vue'
import gsap from 'gsap'

export default {
  name: 'ItinerarioPoster',
  setup() {
    const eventos = [
      {
        nombre: 'Ceremonia',
        hora: '6:00 PM',
        icono: require('@/assets/bfcc6cffb98ca41900a2ac089000b051.png')
      },
        {
        nombre: 'Presentación',
        hora: '7:00 PM',
        icono: require('@/assets/coronaak.png')
      },
      {
        nombre: 'Cena',
        hora: '8:00 PM',
        icono: require('@/assets/e227f5d6c011bd347a56dee847c91f5e.png')
      },
      {
        nombre: 'Fiesta',
        hora: '10:00 PM - en adelante',
        nota: '¡A disfrutar la fiesta!',
        icono: require('@/assets/1afa8992bb52e2f05b3e3a9edc348a3a.png')
      }
    ]

    const itemRefs = ref([])
    const sectionRef = ref(null)

    onMounted(() => {
      itemRefs.value.forEach((el, index) => {
        if (!el) return

        const icon = el.querySelector('.poster-icon')
        const text = el.querySelector('.poster-text')

        gsap.set([icon, text], { opacity: 0 })

        const animations = [
          { y: 40 },
          { x: -40 },
          { scale: 0.85 },
          { x: 40 },
          { y: -40 },
          { scale: 0.9 },
          { x: -30 },
          { y: 30 }
        ]

        const fromVars = animations[index % animations.length]

        const observer = new IntersectionObserver((entries, obs) => {
          entries.forEach(entry => {
            if (!entry.isIntersecting) return

            gsap.fromTo(
              icon,
              { ...fromVars, opacity: 0 },
              { opacity: 1, x: 0, y: 0, scale: 1, duration: 1, ease: 'power3.out' }
            )

            gsap.fromTo(
              text,
              { y: 20, opacity: 0 },
              { y: 0, opacity: 1, duration: 1, delay: 0.2, ease: 'power2.out' }
            )

            obs.unobserve(entry.target)
          })
        }, { threshold: 0.3 })

        observer.observe(el)
      })
    })

    return { eventos, itemRefs, sectionRef }
  }
}
</script>

<style scoped>
.itinerario-poster {
  background: #a4bcac;
  padding: 90px 20px;
  text-align: center;
  position: relative;
  margin-top: 45px;
  margin-bottom: 0px;
}

/* ==================== ONDAS MÚLTIPLES FLUIDAS (SVG) ==================== */
.itinerario-poster::before,
.itinerario-poster::after {
  content: '';
  position: absolute;
  left: 0;
  width: 100%;
  height: 30px;
  background-repeat: repeat-x;
  background-size: 100px 30px;
  z-index: 10;
  pointer-events: none;
}

/* Onda Superior Múltiple */
.itinerario-poster::before {
  top: -29px;
background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 100 30' preserveAspectRatio='none'%3E%3Cpath d='M0,30 C25,0 75,0 100,30 Z' fill='%23a4bcac'/%3E%3C/svg%3E");
}

/* Onda Inferior Múltiple (Efecto reflejo/espejo) */
.itinerario-poster::after {
  }

.poster-title {
  font-family: 'Playfair Display', serif;
  font-size: 44px;
  letter-spacing: 2px;
  color: #514e4e;
  margin-bottom: 50px;
}

.poster-item {
  margin-bottom: 42px;
}

.poster-icon {
  width: 114px;
  height: auto;
  margin-bottom: 12px;
}

.poster-text {
  font-family: 'Playfair Display', serif;
  color: #282727;
  line-height: 1.4;
}

.evento-nombre {
  display: block;
  font-size: 22px;
}

.evento-hora {
  display: block;
  font-size: 20px;
  font-style: italic;
  margin-top: 4px;
}

.evento-nota {
  display: block;
  font-size: 16px;
  margin-top: 6px;
  color: #6a6666;
}
</style>